import { Component } from "@angular/core";
import { ParameterService } from "../services/parameter.service";

@Component({
  selector: "app-footer-cmp",
  templateUrl: "footer.component.html",
  styleUrls: ["./footer.css"],
})
export class FooterComponent {
  currentYear: Date = new Date();
}
